import apiClient from '@/services/api/clients/api-client.js'
import { API_URL } from '@/config'

const path = `${API_URL}/member`
const client = apiClient.build(path)

//ToDo: user a real cache service
const cache = {}

client.fetchCached = id => {
  if (cache[id]) {
    console.log('member cache hit')
    return Promise.resolve(cache[id])
  }

  //Item is already being fetched
  if (cache[`_${id}`]) {
    console.log('member cache pending')
    return Promise.resolve(cache[`_${id}`])
  }

  console.log('member cache miss')

  const p = client.fetch(id)
  cache[`_${id}`] = p.then(
    member => {
      cache[id] = member
      return member
    },
    () => {
      return {}
    }
  )

  return p
}

export default client
